const OPEN_DEAL_NUMBER_DIALOG = '@deals/open-deal-number-dialog';
const OPEN_DEAL_NUMBER_SELECT = '@deals/open-deal-number-select';

export interface OpenDealNumberDialogAction {
  type: typeof OPEN_DEAL_NUMBER_DIALOG;
  payload: {
    isOpened: boolean;
  };
}

export interface SelectDealNumberAction {
  type: typeof OPEN_DEAL_NUMBER_SELECT;
  payload: {
    selected: number;
    address: string;
  };
}


type ReasonAction = OpenDealNumberDialogAction
  | SelectDealNumberAction;


interface State {
  isOpened: boolean;
  selected: number;
  address: string;
}

const initialState: State = {
  isOpened: false,
  selected: 0,
  address: ''
};


export const dealNumberDialogReducer = (
  state: State = initialState,
  action: ReasonAction
) => {
  switch (action.type) {
    case OPEN_DEAL_NUMBER_DIALOG:
      return {
        ...state,
        isOpened: action.payload.isOpened
      };
    case OPEN_DEAL_NUMBER_SELECT:
      return {
        ...state,
        selected: action.payload.selected,
        address: action.payload.address
      };
    default:
      return state;
  }
};


export const openDealNumberDialog = (isOpened: boolean) => {
  return {
    type: OPEN_DEAL_NUMBER_DIALOG,
    payload: {
      isOpened
    }
  };
};



export const selectDealsNumberDialog = (selected: number, address: string) => {
  return {
    type: OPEN_DEAL_NUMBER_SELECT,
    payload: {
      selected,
      address
    }
  };
};